import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '../views/LoginView.vue';
import UserListView from '../components/user/UserList.vue';
import UserInfoView from '../components/user/UserInfo.vue';
import AuditListView from '../components/audit/AuditList.vue';
import AuditInfoView from '../components/audit/AuditInfo.vue';
import ProjectListView from '../components/project/ProjectList.vue';
import ProjectInfoView from '../components/project/ProjectInfo.vue';
import DeviceListView from '../components/device/DeviceList.vue';
import DeviceInfoView from '../components/device/DeviceInfo.vue';
import DataListView from '../components/data/DataList.vue';
import DataInfoView from '../components/data/DataInfo.vue';
import DataSearchView from '../components/data/DataSearch.vue';
import i18n from '../i18n';
import {
  // eslint-disable-next-line no-unused-vars
  hasJwt,
  getExpirationTime,
  // getPermission,
  resetJwt,
} from '../User';

const routes = [
  {
    path: '/',
    name: 'home',
    component: ProjectListView,
    meta: {
      titleKey: 'listProject',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      titleKey: 'login',
    },
  },
  {
    path: '/logout',
    name: 'logout',
  },
  {
    path: '/project',
    name: 'listProject',
    component: ProjectListView,
    meta: {
      titleKey: 'listProject',
      requiresAuth: true,
      permission: 2,
      back: '/project',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/project/:type/:page/:search/:checked/:start/:end/:row/:mode',
    name: 'searchProject',
    component: ProjectListView,
    meta: {
      titleKey: 'searchProject',
      requiresAuth: true,
      permission: 2,
      back: '/project',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/project/new',
    name: 'newProject',
    component: ProjectInfoView,
    meta: {
      titleKey: 'newProject',
      requiresAuth: true,
      permission: 2,
      back: '/project',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/project/edit/:id',
    name: 'editProject',
    component: ProjectInfoView,
    meta: {
      titleKey: 'editProject',
      requiresAuth: true,
      permission: 2,
      back: '/project',
    },
    props: {
      type: 1,
    },
  },
  {
    path: '/project/:id',
    name: 'projectInfo',
    component: ProjectInfoView,
    meta: {
      titleKey: 'projectInfo',
      requiresAuth: true,
      permission: 2,
      back: '/project',
    },
    props: {
      type: 2,
    },
  },
  {
    path: '/device',
    name: 'listDevice',
    component: DeviceListView,
    meta: {
      titleKey: 'listDevice',
      requiresAuth: true,
      permission: 2,
      back: '/device',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/device/:type/:page/:search/:checked/:start/:end/:row/:mode',
    name: 'searchDevice',
    component: DeviceListView,
    meta: {
      titleKey: 'searchDevice',
      requiresAuth: true,
      permission: 2,
      back: '/device',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/device/new',
    name: 'newDevice',
    component: DeviceInfoView,
    meta: {
      titleKey: 'newDevice',
      requiresAuth: true,
      permission: 2,
      back: '/device',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/device/edit/:id',
    name: 'editDevice',
    component: DeviceInfoView,
    meta: {
      titleKey: 'editDevice',
      requiresAuth: true,
      permission: 2,
      back: '/device',
    },
    props: {
      type: 1,
    },
  },
  {
    path: '/device/:id',
    name: 'deviceInfo',
    component: DeviceInfoView,
    meta: {
      titleKey: 'deviceInfo',
      requiresAuth: true,
      permission: 2,
      back: '/device',
    },
    props: {
      type: 2,
    },
  },
  {
    path: '/user',
    name: 'listUser',
    component: UserListView,
    meta: {
      titleKey: 'listUser',
      requiresAuth: true,
      permission: 2,
      back: '/user',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/user/:type/:page/:search/:checked/:start/:end/:row/:mode',
    name: 'searchUser',
    component: UserListView,
    meta: {
      titleKey: 'searchUser',
      requiresAuth: true,
      permission: 2,
      back: '/user',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/user/new',
    name: 'newuser',
    component: UserInfoView,
    meta: {
      titleKey: 'newUser',
      requiresAuth: true,
      permission: 2,
      back: '/user',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/user/edit/:id',
    name: 'edituser',
    component: UserInfoView,
    meta: {
      titleKey: 'editUser',
      requiresAuth: true,
      permission: 2,
      back: '/user',
    },
    props: {
      type: 1,
    },
  },
  {
    path: '/user/:id',
    name: 'userInfo',
    component: UserInfoView,
    meta: {
      titleKey: 'userInfo',
      requiresAuth: true,
      permission: 2,
      back: '/user',
    },
    props: {
      type: 2,
    },
  },
  {
    path: '/audit',
    name: 'listAudit',
    component: AuditListView,
    meta: {
      titleKey: 'audit',
      requiresAuth: true,
      permission: 2,
      back: '/audit',
    },
    props: {
      type: 2,
    },
  },
  {
    path: '/audit/:type/:page/:search/:checked/:start/:end/:row/:mode',
    name: 'searchAudit',
    component: AuditListView,
    meta: {
      titleKey: 'searchAudit',
      requiresAuth: true,
      permission: 2,
      back: '/audit',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/audit/:id',
    name: 'auditInfo',
    component: AuditInfoView,
    meta: {
      titleKey: 'auditInfo',
      requiresAuth: true,
      permission: 2,
      back: '/audit',
    },
    props: {
      type: 2,
    },
  },
  {
    path: '/data',
    name: 'listData',
    component: DataListView,
    meta: {
      titleKey: 'listData',
      requiresAuth: true,
      permission: 2,
      back: '/data',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/data/new',
    name: 'newData',
    component: DataInfoView,
    meta: {
      titleKey: 'newData',
      requiresAuth: true,
      permission: 2,
      back: '/data',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/data/edit/:id',
    name: 'editData',
    component: DataInfoView,
    meta: {
      titleKey: 'editData',
      requiresAuth: true,
      permission: 2,
      back: '/data',
    },
    props: {
      type: 1,
    },
  },
  {
    path: '/data/:id',
    name: 'dataInfo',
    component: DataInfoView,
    meta: {
      titleKey: 'dataInfo',
      requiresAuth: true,
      permission: 2,
      back: '/data',
    },
    props: {
      type: 2,
    },
  },
  {
    path: '/history',
    name: 'listHistory',
    component: DataSearchView,
    meta: {
      titleKey: 'listHistory',
      requiresAuth: true,
      permission: 2,
      back: '/history',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/history/:type/:page/:search/:checked/:start/:end/:row/:mode',
    name: 'searchHistory',
    component: DataSearchView,
    meta: {
      titleKey: 'searchHistory',
      requiresAuth: true,
      permission: 2,
      back: '/history',
    },
    props: {
      type: 0,
    },
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/login',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/api')) {
    window.location.href = to.fullPath;
    return;
  }
  const jwt = hasJwt();
  if (to.name === 'logout') {
    resetJwt();
    next('/login');
  } else if (to.name === 'login') {
    if (jwt) {
      next('/');
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!jwt) {
      next('/login');
    } else {
      const currentTime = Date.now() / 1000;
      if (getExpirationTime() < currentTime) {
        resetJwt();
        next('/login');
        // } else if (getPermission() > to.meta.permission) {
        //   next('/');
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  const currentLang = localStorage.getItem('language') || 'en';
  i18n.global.locale.value = currentLang;
  if (to.meta.titleKey) {
    document.title = `${i18n.global.t(to.meta.titleKey)} - ${i18n.global.t('UTBMP')}`;
  }
  next();
});

export default router;
